import React from "react";
import ReactDOM from "react-dom";

import App from "./Components/App";

ReactDOM.render(<App></App>, document.getElementById("root"));
